import React, { useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { bookPreviewPages } from '../data/bookPreview';
export function BookPreviewCarousel() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(0);
  const total = bookPreviewPages.length;
  const goTo = (i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const next = Math.max(0, Math.min(total - 1, i));
    track.scrollTo({
      left: next * track.clientWidth,
      behavior: 'smooth'
    });
  };
  const handleScroll = () => {
    const track = trackRef.current;
    if (!track) return;
    setActive(Math.round(track.scrollLeft / track.clientWidth));
  };
  return <div className="mt-5 md:mt-8" aria-roledescription="carrusel" aria-label="Vista previa del interior del libro" data-id="element-47" data-mp="2mnuli0sme3k">
      <div className="mb-2 flex items-center justify-between text-xs text-muted" data-id="element-48" data-mp="31bmsd2h3783x">
        <span data-id="element-49" data-mp="36apo1wb6g1z8">Vista previa del interior</span>
        <span className="tabular-nums" data-id="element-50" data-mp="369eflj6se61s">
          {active + 1} / {total}
        </span>
      </div>

      <div className="relative" data-id="element-51" data-mp="33u5as7sgjjdf">
        <div ref={trackRef} onScroll={handleScroll} className="flex snap-x snap-mandatory overflow-x-auto rounded-xl [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-52" data-mp="2zpxm2am023f7">
          {bookPreviewPages.map((page, i) => <figure key={page.src} className="w-full shrink-0 snap-center" aria-label={`Página ${i + 1} de ${total}: ${page.title}`} data-id="element-53" data-mp="2pyjt6lok01v1" data-mpi={i}>
              <div className="aspect-[5/7] w-full overflow-hidden rounded-xl bg-white" data-id="element-54" data-mp="2g15d4n6jlf39">
                <img src={page.src} alt={`Página interior del libro: ${page.title}`} loading="lazy" decoding="async" width={560} height={784} className="h-full w-full object-contain" data-id="element-55" data-mp="2c1eoap0kt91d" />
              </div>
            </figure>)}
        </div>

        <button type="button" onClick={() => goTo(active - 1)} disabled={active === 0} aria-label="Página anterior" className="absolute left-2 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-ink/80 text-cream transition-opacity duration-150 hover:bg-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-gold disabled:pointer-events-none disabled:opacity-0" data-id="element-56" data-mp="oe8outpvosc2">
          <ChevronLeftIcon aria-hidden="true" className="h-5 w-5" data-id="element-57" data-mp="1c54mw8kxgjrr" />
        </button>
        <button type="button" onClick={() => goTo(active + 1)} disabled={active === total - 1} aria-label="Página siguiente" className="absolute right-2 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-ink/80 text-cream transition-opacity duration-150 hover:bg-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-gold disabled:pointer-events-none disabled:opacity-0" data-id="element-58" data-mp="y4ttoyw5at3f">
          <ChevronRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-59" data-mp="3g8teyn0ov114" />
        </button>
      </div>

      <div className="mt-3 flex justify-center gap-2" data-id="element-60" data-mp="3bba13o7wkq9p">
        {bookPreviewPages.map((page, i) => <button key={page.src} type="button" onClick={() => goTo(i)} aria-label={`Ir a ${page.title}`} aria-current={active === i} className={`h-1.5 rounded-full transition-[width,background-color] duration-200 ease-out ${active === i ? 'w-6 bg-gold' : 'w-1.5 bg-line hover:bg-muted'}`} data-id="element-61" data-mp="3p98bkij3s2jx" data-mpi={i} />)}
      </div>
    </div>;
}